export default "__VITE_ASSET__894355d4__"